import { render } from "./NotesModal.vue?vue&type=template&id=1dc5d09c&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=1dc5d09c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc5d09c"],['__file',"src/components/NotesModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dc5d09c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dc5d09c', __exports__)) {
    api.reload('1dc5d09c', __exports__)
  }
  
  module.hot.accept("./NotesModal.vue?vue&type=template&id=1dc5d09c&scoped=true", () => {
    api.rerender('1dc5d09c', render)
  })

}


export default __exports__